import PropTypes from 'prop-types';
import React, { createContext, useContext, useState, useMemo } from 'react';

const DashboardContext = createContext();

export function DashboardProvider({ children }) {
  const [showListing, setShowListing] = useState({ toggle: false, type: 'reach' });

  const onOpenListing = (type) => setShowListing({ ...showListing, toggle: true, type });
  const onCloseListing = (type) => setShowListing({ ...showListing, toggle: false, type });

  const value = useMemo(
    () => ({
      showListing,
      onOpenListing,
      onCloseListing,
    }),
    [showListing],
  );

  return <DashboardContext.Provider value={value}>{children}</DashboardContext.Provider>;
}

DashboardProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useDashboard = () => useContext(DashboardContext);
